import { render, staticRenderFns } from "./ViewEmployeePage.vue?vue&type=template&id=1647bf3b&scoped=true&"
import script from "./ViewEmployeePage.vue?vue&type=script&lang=js&"
export * from "./ViewEmployeePage.vue?vue&type=script&lang=js&"
import style0 from "./ViewEmployeePage.vue?vue&type=style&index=0&id=1647bf3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647bf3b",
  null
  
)

export default component.exports